import React from 'react';
import ReactDOM from 'react-dom';
import Invite from './invite';

ReactDOM.render(<Invite/>, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/invite/index.js